const QuestionTypes = {
  FlashCard: 0,
  MC: 1,
  FillIn: 2,
  CR: 3,
  MultiOption: 4,
  MultiCheckbox: 5,
  DragDrop: 6,
  Skill: 99,
  Invalid: 7
};
    
export default QuestionTypes;